// src/pages/Landing.jsx
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LandingInner, { IntroOverlay } from "./landing/LandingInner";

export default function Landing() {
  const location = useLocation();

  const params = new URLSearchParams(location.search || "");
  const noIntro = params.get("noIntro") === "1";
  const introSeen = typeof window !== "undefined" && window.sessionStorage?.getItem("wow_intro_seen") === "1";
  const skipIntro = noIntro || Boolean(location.hash) || introSeen;

  const [showIntro, setShowIntro] = useState(!skipIntro);

  useEffect(() => {
    // Show intro once per session (or skip when returning to a specific section)
    if (!showIntro) {
      try {
        window.sessionStorage?.setItem("wow_intro_seen", "1");
      } catch {
        // ignore
      }
      return;
    }

    const timer = window.setTimeout(() => setShowIntro(false), 4500);
    return () => window.clearTimeout(timer);
  }, [showIntro]);

  return (
    <>
      {showIntro ? <IntroOverlay /> : <LandingInner />}
    </>
  );
}





